import { Component, OnInit, ViewChild, ViewContainerRef, Input, Renderer2, NgZone } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { countries } from 'src/app/resources/countries';
import { SelectEvent, FileRestrictions, CancelEvent } from '@progress/kendo-angular-upload';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { NotificationService } from '@progress/kendo-angular-notification';
import { DialogCloseResult, DialogContentBase, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { IntlService } from '@progress/kendo-angular-intl';
import { ApiService } from 'src/app/services/http/api.service';
import { BaseHttpResponse, BaseHttpResult } from 'src/app/models/base-http-response';
import { Enum } from 'src/app/models/enum.model';
import { AddEvent, RemoveEvent, GridComponent } from '@progress/kendo-angular-grid';
import { CostCenter } from 'src/app/models/cost-center.model';

@Component({
  selector: 'app-cost-centers-form-component',
  templateUrl: './cost-centers-form.component.html'
})
export class CostCentersFormComponent extends DialogContentBase implements OnInit {
  @ViewChild("container", { read: ViewContainerRef })
  public container: ViewContainerRef | undefined;
  public editDataItem: any;
  public currentGridRef: GridComponent | undefined;
  @Input() public isNew = false;
  public formGroup: FormGroup = new FormGroup({});
  public countries = countries;
  public phoneNumberMask = '(+9) 0000-000-00-00';
  public fileRestrictions: FileRestrictions = {
    allowedExtensions: ['.png', '.jpeg', '.jpg'],
    maxFileSize: 1048576
  };
  public avatars?: NodeList;
  public imgURL: string = 'assets/noimage.png';
  public formValue: CostCenter = {
    nome: '',
    codigo: '',
    estado: 1,
    refImagem: 0,
    traducoes: [
      { refLingua: 1, valor: '', descricaoLingua: '', id: 0 },
      { refLingua: 2, valor: '', descricaoLingua: '', id: 0 },
      { refLingua: 3, valor: '', descricaoLingua: '', id: 0 }
    ],
    id: 0,
  };
  lEstadosCentroDeCusto: Enum[] = [];
  public customMsgService: CustomMessagesService;

  constructor(private dialogService: DialogService, public msgService: MessageService, private notificationService: NotificationService, public override dialog: DialogRef, private intl: IntlService, private api: ApiService, private formBuilder: FormBuilder, private renderer: Renderer2, public zone: NgZone,) {
    super(dialog);

    this.setFormValues();
    this.customMsgService = this.msgService as CustomMessagesService;
    this.placeHolder.description = this.customMsgService.translate('selecionartag');
  }
  public maxlength = 20;
  public charachtersCount = 0;
  public counter = `${this.charachtersCount}/${this.maxlength}`;

  ngOnInit(): void {
    this.api
      .getRequest<BaseHttpResponse<Enum[]>>("CentroDeCusto/GetEstadosCentroDeCusto")
      .then((data) => {
        this.lEstadosCentroDeCusto = data.value;
      })
      .catch((err) => { });
  }

  public placeHolder: any = {
    descricao: "",
    id: 0,
  };

  public inputBlur() {
    if (this.formGroup.controls['en'].value == '' && this.formGroup.controls['fr'].value == '' && this.formValue.id == 0) {
      var texto = this.formGroup.controls['pt'].value;
      this.formGroup.controls['en'].setValue(texto);
      this.formGroup.controls['fr'].setValue(texto);
    }
  }

  public getAllRows(): Array<HTMLTableElement> {
    var l = Array.from(document.querySelectorAll(".k-grid tr"));
    return Array.from(document.querySelectorAll(".k-grid tr"));
  }

  public setFormValues() {

    var ptValue = this.formValue.traducoes.filter(_ling => _ling.refLingua === 1)[0].valor;
    var enValue = this.formValue.traducoes.filter(_ling => _ling.refLingua === 2)[0].valor;
    var frValue = this.formValue.traducoes.filter(_ling => _ling.refLingua === 3)[0].valor;

    this.formGroup = new FormGroup({
      pt: new FormControl(ptValue),
      en: new FormControl(enValue),
      fr: new FormControl(frValue),
      imagem: new FormControl(null),
      codigo: new FormControl(this.formValue?.codigo),
      estado: new FormControl({ id: this.formValue?.estado }),
    });

    this.LoadImage();
  }

  public saveChanges(): void {

    this.formGroup.markAllAsTouched();
    var imagem = undefined;

    if (this.formGroup.controls['imagem'].value != undefined)
      imagem = this.formGroup.controls['imagem'].value[0];

    this.formValue.traducoes.filter(_ling => _ling.refLingua === 1)[0].valor = this.formGroup.controls['pt'].value;
    this.formValue.traducoes.filter(_ling => _ling.refLingua === 2)[0].valor = this.formGroup.controls['en'].value;
    this.formValue.traducoes.filter(_ling => _ling.refLingua === 3)[0].valor = this.formGroup.controls['fr'].value;
    this.formValue.codigo = this.formGroup.controls['codigo'].value;
    this.formValue.estado = this.formGroup.controls['estado'].value.id;

    this.api.saveMultiPart<BaseHttpResponse<CostCenter>>("CentroDeCusto/SaveCentroDeCustoComImagem", this.formValue, imagem).then((res) => {
      if (res.ok) {

        this.notificationService.show({
          content: this.customMsgService.translate('registoGravadoComSucesso'),
          animation: { type: 'slide', duration: 500 },
          position: { horizontal: 'center', vertical: 'bottom' },
          type: { style: 'success', icon: true },
          hideAfter: 2000
        });
        this.dialog.close();

      } else {
        this.notificationService.show({
          appendTo: this.container,
          content: res.message,
          animation: { type: 'slide', duration: 500 },
          position: { horizontal: 'center', vertical: 'top' },
          type: { style: 'error', icon: true },
          hideAfter: 4000

        });
      }
    });
  }

  public cancelChanges(): void {
    this.setFormValues();
  }

  public isFileAllowed(file: any): boolean {
    return <boolean>this.fileRestrictions.allowedExtensions?.includes(file.extension);
  }

  public selectAvatar(ev: SelectEvent): void {
    const reader = new FileReader();
    const file = ev.files[0];
    const avatars = this.avatars;
    if (file.rawFile && this.isFileAllowed(file)) {
      reader.onload = (_event) => {
        this.imgURL = reader.result?.toString() as string;
      }
      reader.readAsDataURL(file.rawFile);
    }
  }

  LoadImage() {
    if (this.formValue.refImagem == null) return;

    this.api
      .getBytes("Imagem/DownloadImage?refImage=" + this.formValue.refImagem)
      .then((blob) => {
        const binaryData = [];
        binaryData.push(blob);
        this.preview(new Blob(binaryData, { type: "image/png" }));
      });
  }

  preview(file: any) {
    const mimeType = file.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (_event) => {
      this.imgURL = reader.result?.toString() as string;
    };
  }

  public addHandler(): void {
    this.editDataItem = { PT: '', EN: '', FR: '', refTipoFerramenta: this.formValue.id, ID: 0 };
    this.isNew = true;
  }

  public editHandler(args: AddEvent): void {
    this.editDataItem = args.dataItem;
    this.isNew = false;
  }

  public cancelHandler(): void {
    this.editDataItem = undefined;
  }

  public saveHandler(updatedDataItem: any): void {
    this.formGroup.markAsDirty();
    this.editDataItem = undefined;
  }

  public removeHandler(args: RemoveEvent): void {
    this.delete(args.dataItem);
  }

  public noRecordsMsg = "No records available yet. Please drop a row.";
  public onDragStart(e: DragEvent, grid: GridComponent): void {
    this.currentGridRef = grid;
    const draggedElement: string = (e.target as HTMLElement).innerText;
    if (draggedElement.includes("ID") || draggedElement === this.noRecordsMsg) {
      e.preventDefault();
    }
  }

  public onDrop(
    e: DragEvent,
    dragStartGridRef: GridComponent

  ): void {
  }

  public onDragOver(e: DragEvent, grid: GridComponent): void {
  }

  public delete(e: any): void {
    var sim = this.customMsgService.translate('yes');
    var nao = this.customMsgService.translate('no');
    const dialog: DialogRef = this.dialogService.open({
      appendTo: this.container,
      title: this.customMsgService.translate('confirmacao'),
      content: this.customMsgService.translate('desejaRemover'),
      actions: [{ text: nao }, { text: sim, themeColor: "primary" }],
      width: 450,
      height: 200,
      minWidth: 250,
    });

    dialog.result.subscribe((result) => {
      if (result instanceof DialogCloseResult) {
      } else if (result.text == sim) {
        this.api.cruddelete<BaseHttpResult>('CentroDeCusto', e.id).
          then(res => {
            if (res.ok) {
              this.notificationService.show({
                appendTo: this.container,
                content: this.customMsgService.translate('registoApagadoComSucesso'),
                animation: { type: 'slide', duration: 500 },
                position: { horizontal: 'center', vertical: 'top' },
                type: { style: 'success', icon: true },
                hideAfter: 2000
              });
            } else {
              this.notificationService.show({
                appendTo: this.container,
                content: res.message,
                animation: { type: 'slide', duration: 500 },
                position: { horizontal: 'center', vertical: 'top' },
                type: { style: 'error', icon: true },
                hideAfter: 4000
              });
            }

          }).
          catch(err => {
          });
      }
    });
  }
}
